// Margin Overlap Module
// Adds margins to adjacent sections to create overlap effect

const MarginOverlap = {
    init() {
        const sectionsWithOverlap = document.querySelectorAll('[data-margin-overlap]');
        
        sectionsWithOverlap.forEach(section => {
            const overlapType = section.getAttribute('data-margin-overlap');
            
            if (overlapType === 'none') return;
            
            // Get all sections on the page
            const allSections = document.querySelectorAll('section');
            const sectionArray = Array.from(allSections);
            const currentIndex = sectionArray.indexOf(section);
            
            if (currentIndex === -1) return;
            
            // Add padding to adjacent sections based on overlap type
            if (overlapType === 'top') {
                const prevSection = sectionArray[currentIndex - 1];
                if (prevSection) {
                    // Remove existing margin classes and add padding
                    prevSection.classList.remove('mb-margins');
                    prevSection.classList.add('pb-margins');
                }
            }
            
            if (overlapType === 'bottom') {
                const nextSection = sectionArray[currentIndex + 1];
                if (nextSection) {
                    // Remove existing margin classes and add padding
                    nextSection.classList.remove('mt-margins');
                    nextSection.classList.add('pt-margins');
                }
            }
        });
    }
};

export default MarginOverlap;